/**
 * Controls and updates the `selectedScale` field of an updated item object based on provided conditions.
 *
 * The logic:
 * - Removes `selectedScale` from `updatedItem` if:
 *   - `selectedComparator` is provided, OR
 *   - `selectedCapability` is provided and its `name` differs from `updatedItem.selectedCapability?.name`, OR
 *   - `deviceId` is provided and differs from `updatedItem.deviceId`.
 * - If `selectedScale` is provided, assigns it to `updatedItem.selectedScale`.
 *
 * @param {Object} params - The parameters object.
 * @param {string} [params.selectedScale] - The new scale value to set (e.g., `"fahrenheit"`, `"celsius"`). Optional.
 * @param {string} [params.deviceId] - The device identifier. Optional.
 * @param {Object} [params.selectedComparator] - Comparator configuration. Optional.
 * @param {Object} [params.selectedCapability] - Capability configuration. Optional.
 * @param {Object} [params.updatedItem] - The object representing the updated item. This object will be mutated.
 */
export const controlSelectedScaleField = ({
    selectedScale,
    selectedComparator,
    selectedCapability,
    updatedItem,
    deviceId,
}) => {
    if (
        selectedComparator ||
        (selectedCapability && selectedCapability.name !== updatedItem.selectedCapability?.name) ||
        (deviceId && deviceId !== updatedItem.deviceId)
    ) {
        delete updatedItem.selectedScale;
    }

    selectedScale && (updatedItem.selectedScale = selectedScale);
};
